import { postPublic } from "../data/api";

export async function sendMessage (params) {
    let contact = {
        Sender: params.sender,
        Message: params.message
    };
    return await postPublic(contact, 'contact')
}